export default __webpack_public_path__ + "static/media/permit_completed.96121445.svg";